import { render } from "./Contact.vue?vue&type=template&id=6025231c&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=6025231c&scoped=true&lang=css"

import exportComponent from "/home/vrushaket@rhythm.local/vrushaket/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6025231c"]])

export default __exports__